var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewYorkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 155,
    viewBox: "0 0 154 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23_85)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 64,
    r: 64,
    fill: "#07587F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5856 88.69V89.3438L88.0115 90.3249L88.6019 88.8207L89.5856 88.69ZM96.9315 88.3627L95.4885 88.8862L94.0455 89.0169L96.0789 88.5589L96.9315 88.3627ZM97.7185 88.5589L96.4726 88.8207V88.69L100.933 87.0547L97.7185 88.5589ZM105.524 82.8034L102.244 85.5505H103.753L104.933 84.0459L106.114 84.1114L106.18 83.6534L106.77 84.3076L109 83.4572L101.391 87.0547L102.179 86.5967L92.6681 89.0169L93.8489 89.2786L90.8319 89.6711L92.3404 89.0169L91.6845 88.5589L91.0285 88.8207L91.2252 89.2786L90.1104 89.54L89.7822 88.69L90.8319 87.1854L92.3404 87.0547V86.5316L92.537 86.7278L92.6681 85.8774L93.2585 86.5967L93.5207 85.6812L94.7015 85.7467L95.0297 85.0925L95.6852 85.6812L95.3574 85.0925L96.997 85.5505L97.9156 84.8963L102.244 84.6345L104.671 82.6723L105.524 82.8034ZM107.623 81.2988L107.426 81.1681L108.213 80.8412L107.754 81.2988H107.623ZM48.1331 59.9109L47.6084 60.5652L47.2148 60.2383L47.2804 59.5185L48.1331 59.9109ZM71.2203 49.5114L70.7615 49.9038L71.3519 49.0538V49.4462L71.2203 49.5114ZM72.5322 46.045L72.7293 46.1756L71.9418 46.3719L72.0734 46.1756L72.5322 46.045ZM73.9096 45.3256L73.5163 45.6525L72.9915 46.1756L72.8604 45.6525L73.9096 45.3256ZM82.8956 38H95.3574V38.6541L95.2919 42.5786L95.9478 44.5408L95.6196 46.9605L94.7015 49.0538L95.3574 52.2584L94.8981 54.2862L95.0297 54.7441L95.9478 54.1555L96.2755 55.0055L96.4726 64.2933L94.4393 71.9458L94.0455 81.2988L94.7015 82.0837L92.537 83.4572L93.2585 84.6345L91.75 86.0736L91.8811 86.5967L90.8319 86.7278L90.1104 87.9051L91.2252 84.3076L90.7008 80.9064L90.2415 81.495L90.8974 84.6345L83.9448 80.4488L83.5515 79.6639L81.3871 78.8135L80.7967 77.5706L80.7311 75.0853L79.1566 74.4311L78.4352 72.9925L40 71.4879L40.1968 68.4139L45.7063 65.1437L46.7557 63.574L48.1331 62.8542L47.8051 60.5652L48.2643 59.7147L46.7557 59.061L46.8213 56.9677L52.8555 55.9215L58.1681 56.7063L59.5455 57.8836L61.4478 57.4257L64.7926 58.145L65.0552 57.4912L66.9574 57.1639L69.4496 55.0055L70.7615 55.1366L71.483 54.3517L71.5485 53.5013L71.3519 53.6975L70.6959 51.2773L71.2203 50.6887L71.3519 51.2773L72.7293 49.5114L71.483 49.7731L72.2045 48.9227L71.483 48.5958L70.6959 49.1189L70.2367 48.0072L74.5 45.1945L75.8119 42.7748L79.5504 39.6352L82.8956 38Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23_85",
    x: 0.9,
    y: 0,
    width: 152.2,
    height: 154.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_85",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewYorkCircle);
export default __webpack_public_path__ + "static/media/NewYorkCircle.fa700e2dfbae7e6eb85fd4bf690e6f6d.svg";
export { ForwardRef as ReactComponent };